<template>
  <div>
    <Table :rows="list" :columns="columns" :columnID="'id'" containerClass="m-0">
      <template #rows="{ rows }">
        <OrdenDeServicioLiquidarRow v-for="row in rows" :key="row.id" :item="row"></OrdenDeServicioLiquidarRow>
        <tr class="table-secondary" v-for="(val, moneda) in total" :key="moneda">
          <td :colspan="8" class="text-right">
            <strong>TOTAL {{ moneda }}</strong>
          </td>
          <td class="text-center">{{ val | number(2) }}</td>
          <td></td>
        </tr>
      </template>
    </Table>
  </div>
</template>

<script>
import OrdenDeServicioLiquidarRow from "./OrdenDeServicioLiquidarRow.vue";
import Table from "../../shared/components/Table.vue";
import { mapState, mapGetters } from "vuex";
export default {
  components: { Table, OrdenDeServicioLiquidarRow },
  computed: {
    columns() {
      let columns = [
        {
          key: "agencia",
        },
        {
          key: "file",
          width: 90,
        },
        {
          key: "nombre",
        },
        {
          key: "nroAdultos",
          label: "PAX",
          width: 40,
          head_class: "text-center",
        },
        {
          key: "nroNinos",
          label: "CHD",
          width: 40,
          head_class: "text-center",
        },
        {
          key: "hotel",
        },
        {
          key: "servicioTipo",
          label: "Tipo",
          width: 40,
          head_class: "text-center",
        },
        {
          key: "moneda",
          width: 60,
          head_class: "text-center",
        },
        {
          key: "tarifa",
          label: "Monto",
          width: 60,
          head_class: "text-center",
        },
        {
          key: "observaciones",
        },
      ];

      return columns;
    },
    ...mapState("ordenDeServicio.liquidar", ["list"]),
    ...mapGetters("ordenDeServicio.liquidar", ["total", "estaLiquidado"]),
  },
  methods: {},
};
</script>

<style></style>
